// extracted by mini-css-extract-plugin
module.exports = {"DefaultErrorView":"DefaultErrorView_DefaultErrorView__r4Ih8"};